export const BUTTON_BASE_LAYOUT_CLASS_NAMES = ['inline-flex'] as const;

export const TEXT_BUTTON_LAYOUT_CLASS_NAMES = [
  ...BUTTON_BASE_LAYOUT_CLASS_NAMES,
  'w-fit',
  'max-w-full',
  'shrink-0',
  'whitespace-normal',
  'text-center',
] as const;
